class CartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const button = event.target.closest('[data-upsell-variant-id]');
    if (!button || button.disabled) return;

    const variantId = button.dataset.upsellVariantId;
    if (!variantId) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    const sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        sectionIds.push(el.dataset.sectionId);
      }
    });

    fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sectionIds.join(','),
      }),
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          return;
        }

        const itemCount =
          Array.isArray(response.items)
            ? response.items.reduce((sum, item) => sum + item.quantity, 0)
            : 0;

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: response,
              data: {
                sections: response.sections,
                itemCount,
              },
            },
          })
        );
      })
      .catch((err) => {
        console.error('[cart-upsell]', err);
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  };
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}
